// Build CSS
import 'vite/modulepreload-polyfill'

import '../css/app.css'

// Import JS Modules
import checkBrowser from './modules/check-browser'
import menu_init from './modules/menu'
import scrollTop from './modules/scrollTop'
import wpforms from './modules/wpforms'
import accordion from './modules/accordion'
import wpformspopup from './modules/wpforms-popup'
import migrateYoutube from './modules/migrate-youtube'
import usercentrics from './modules/usercentrics'
import addNofollowAttributes from './modules/add-nofollow-attributes'
import Cookies from 'js-cookie'
import Flickity from 'flickity'
import blockElementorCookie from './modules/blockElementorCookie'

window.Cookies = Cookies;

blockElementorCookie();
usercentrics();


addNofollowAttributes();
checkBrowser();
menu_init();
migrateYoutube();
scrollTop();
wpforms();
wpformspopup();
accordion();

// Filter wird extra eingebunden damit Wordpress die callback URL setzen kann
// filter();
